/** Mirrors `functions/src/zipSlotAds/constants.js` for client validation/display. */

export const SLOT_COUNT = 7;
export const MIN_BID_CENTS = 100;
export const FULL_BOARD_INCREMENT_CENTS = 1000;

export const MIN_TOPUP_CENTS = 500;
export const MAX_TOPUP_CENTS = 1000000;

export const TRANSACTION_PAGE_SIZE = 20;
export const REPORT_ENTRY_SCAN_LIMIT = 500;

export const BID_STATUS = {
  ACTIVE: "active",
  INSUFFICIENT_BALANCE: "insufficient_balance",
  INELIGIBLE: "ineligible",
};

export const LEDGER_TYPE = {
  TOPUP: "topup",
  CLICK_DEBIT: "click_debit",
  REFUND: "refund",
  AUTO_RECHARGE: "auto_recharge",
};

export const COLLECTIONS = {
  AD_BALANCES: "adBalances",
  AD_BALANCE_TRANSACTIONS: "adBalanceTransactions",
  ZIP_SLOT_BIDS: "zipSlotBids",
  ZIP_SLOT_RANKS: "zipSlotRanks",
};
